import React, { useState, useEffect, useCallback, useRef } from "react";
import Header from "../../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import {
  faEdit,
  faTrashAlt,
  faSearch,
  faClipboardCheck,
  faEllipsisH,
  faCircleArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import Table from "../../components/Table";
import Section from "../../components/Section";
import DeleteModal from "../../components/DeleteModal";
import apiClient from "../../axios";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";

const PermissionsList = ({ handleLogout }) => {
  const [data, setData] = useState([]);
  //const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 10;
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const [deleteItem, setDeleteItem] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
    
  useEffect(() => {
    const handleClickOutside = (event) => {
        const isClickInsideDropdown = dropdownRef.current?.contains(event.target);
        const isDropdownItem = event.target.closest(".dm-class");

        if (!isClickInsideDropdown && !isDropdownItem) {
        setOpenDropdown(false);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const hasPermission = (permission) => {
    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    return permissions.includes(permission);
  };

  const fetchAllData = useCallback(async (page = 1) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/admin/permissions?page=${page}`);
      if (Array.isArray(response.data.results)) {
        setData(response.data.results);
        setTotalItems(response.data.total);
      } else {
        setData([response.data.results]);
        setTotalItems(1);
      }
    } catch (error) {
      setIsErrorVisible(true);
      if (error.response && error.response.status === 401) {
        setIsInfoVisible(true);
      }
    } finally {
      setIsSuccessVisible(true);
      setLoading(false);
    }
  }, [])

  const handleRefresh = () => {
    fetchAllData(currentPage);
  };

  const handleSearch = useCallback(
    async (page = 1) => {
      try {
        // Construir la URL con los query params
        const params = new URLSearchParams();
        if (searchTerm) params.append("search", searchTerm);

        const response = await apiClient.get(
          `/admin/permissions?${params.toString()}&page=${page}`
        );

        if (Array.isArray(response.data.results)) {
          setData(response.data.results); // Si es un array, lo dejamos tal cual
        } else {
          setData([response.data.results]); // Si es un objeto, lo encapsulamos en un array
        }
        setTotalItems(response.data.total);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setIsInfoVisible(true);
        }
      }
    },
    [searchTerm]
  );
  const handleFresh = async (code) => {
    //handleSearch(1);
    setCurrentPage(1);
    setSearchTerm(searchInput.trim());
  };

  useEffect(() => {
    if (searchTerm) {
      handleSearch(currentPage);
    } else {
      fetchAllData(currentPage);
    }

  }, [fetchAllData, handleSearch, searchTerm, currentPage]);

  const handleDeleteModal = (item) => {
    setSelectedDeleteItem(item);
    setDeleteItem(true);
  };
  const handleCloseDeleteModal = () => {
    setDeleteItem(false);
    setSelectedDeleteItem(null);
    handleRefresh();
  };
  const handleClick = () => {
    navigate(`/Management`);
  };

  const columns = [
    { title: "Id", key: "id" },
    { title: "Código", key: "code" },
    { title: "Descripción", key: "name" },
    { title: "Acciones", key: "acciones" },
  ];

  const renderRow = (item, index) => (
    <>
      <td>{item.id}</td>
      <td>{item.code}</td>
      <td>{item.description}</td>
      <td>
        <div className="button-container">
          <div className="desktop-buttons">
            <Tooltip id="edit-tooltip" className="custom-tooltip" />
            {hasPermission("PERMISSION_UPDATE") && (
              <button
                data-tooltip-id="edit-tooltip"
                className="icon-button edit-button"
                data-tooltip-content="Editar"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/PermissionFrom/${item.id}`);
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            )}
            <Tooltip id="delete-tooltip" className="custom-tooltip" />
            {hasPermission("PERMISSION_DELETE") && (
              <button
                data-tooltip-id="delete-tooltip"
                data-tooltip-content="Eliminar"
                className="icon-button delete-button"
                onClick={() => handleDeleteModal(item)}
              //onClick={() => handleDelete(item.id)}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </button>
            )}
          </div>

          <div className="mobile-dropdown">
            <div className="dropdown-container-contract">
              <button
                className="icon-button dropdown-button-contract"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDropdown(openDropdown === item.id ? null : item.id);
                }}
              >
                <FontAwesomeIcon icon={faEllipsisH} />
              </button>
              {openDropdown === item.id && (
                <div className="dropdown-menu-contract dm-class">
                  {hasPermission("PERMISSION_UPDATE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/PermissionFrom/${item.id}`);
                      }}
                    >
                      Editar
                    </button>
                  )}
                  {hasPermission("PERMISSION_DELETE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={() => {
                        handleDeleteModal(item);
                        setOpenDropdown(false);
                      }}
                    >
                      Eliminar
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </td>
    </>
  );

  return (
    <div className="home-container">
      <Header onLogout={handleLogout} title="Permisos" />
      <div className="home-content">
        <Section>
          <div className="button-return-container">
            <div className="contener-return">
              <FontAwesomeIcon
                className="basic-shortcut-icon"
                style={{ cursor: "pointer" }}
                icon={faCircleArrowLeft}
                onClick={handleClick}
              />
            </div>
            <div className="filter-form">
              <div className="basic-info-form-group">
                <input
                  type="text"
                  id="customer"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  placeholder="Permiso"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleFresh();
                    }
                  }}
                />
              </div>
              <button className="basic-custom-button" onClick={handleFresh}>
                <FontAwesomeIcon
                  icon={faSearch}
                  className="basic-shortcut-icon"
                />
                Buscar
              </button>
            </div>
          </div>

          <div className="button-add">
            {hasPermission("PERMISSION_CREATE") && (
              <button
                className="basic-custom-button"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/PermissionFrom");
                }}
              >
                <FontAwesomeIcon
                  className="basic-shortcut-icon"
                  icon={faClipboardCheck}
                />
                Crear Nuevo Permiso
              </button>
            )}
          </div>
        </Section>
        <Table
          title="Lista de Permisos"
          rows={data}
          columns={columns}
          icon={faClipboardCheck}
          renderRow={renderRow}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
          onRefresh={handleRefresh}
          loading={loading}
          flagPagination={true}
        />
        <SuccessNotification
          message={"Se ha cargado correctamente"}
          isVisible={isSuccessVisible}
          onClose={() => setIsSuccessVisible(false)}
        />
        <ErrorNotification
          message="Ups! Ocurrió un Problema"
          isVisible={isErrorVisible}
          onClose={() => setIsErrorVisible(false)}
        />
        <LoginNotification
          message="Vuelve a iniciar sesión"
          isVisible={isInfoVisible}
          onClose={() => setIsInfoVisible(false)}
          onLogout={handleLogout}
        />
        {selectedDeleteItem && (
          <DeleteModal
            isVisible={deleteItem}
            onClose={handleCloseDeleteModal}
            identificator={selectedDeleteItem.id}
            url={`/admin/permissions`}
          />
        )}
      </div>
    </div>
  );
};

export default PermissionsList;
